import React from "react";
import { reviews } from "@/mock";
import { Star, Quote } from "lucide-react";

export default function Reviews() {
  return (
    <section id="reviews" className="bg-white py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="text-[11px] tracking-[0.28em] text-[#c60d0d] font-bold uppercase mb-3">
              Reviews
            </div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight text-black">
              WHAT THE CLUB SAYS
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex gap-0.5 text-[#c60d0d]">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={20} fill="#c60d0d" strokeWidth={0} />
              ))}
            </div>
            <div>
              <div className="font-black text-2xl leading-none">4.9</div>
              <div className="text-[11px] tracking-[0.16em] uppercase text-black/50 mt-1">
                12,438 reviews
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {reviews.map((r) => (
            <div
              key={r.name}
              className="border border-black/10 p-6 bg-[#faf9f7] hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <Quote size={24} className="text-[#c60d0d] mb-3" />
              <div className="flex gap-0.5 mb-3 text-[#c60d0d]">
                {[...Array(r.rating)].map((_, i) => (
                  <Star key={i} size={14} fill="#c60d0d" strokeWidth={0} />
                ))}
              </div>
              <h4 className="font-black text-[15px] tracking-tight mb-2">{r.title}</h4>
              <p className="text-[13px] text-black/70 leading-relaxed flex-1">{r.body}</p>
              <div className="mt-5 pt-4 border-t border-black/10">
                <div className="text-[13px] font-bold">{r.name}</div>
                <div className="text-[11px] text-black/50 tracking-[0.12em] uppercase">
                  {r.location} · Verified Buyer
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
